import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { Images } from 'src/assets/export.assets';

@Component({
  selector: 'app-common-header',
  standalone:false,
  templateUrl: './common-header.component.html',
  styleUrl: './common-header.component.scss'
})
export class CommonHeaderComponent {
  @Input() headerLayout!: 'staff' | 'applicant';

  @Input() logoSrc!: string;

  @Output() sealIconClick = new EventEmitter<void>();
  
  onSealIconClick(): void {
    this.sealIconClick.emit();
  }
  
  @Input() profileImageSrc!: string;
  @Input() profileMenu!: MatMenu;
@Input() showProfileMenu = false;
@Input() menuButtons: Array<{
  text: string;
  onClick: () => void;
}> = [];
@Input() onEditProfile?: () => void;
@Input() onChangePassword?: () => void;
@Input() onLogout?: () => void;
@Input() userNameData!: { text: string };
@Input() profileImageClass: string = 'applicant-profile-pic';

@Output() menuAction = new EventEmitter<string>();
// added by omkar on 18/03/2026
  isApplicantProfileMenuOpen = false;

  // Start Code added by Sanchit on 05/06/2026 
   constructor(
      public context: WorkflowContextService
   ) { }
  // End Code added by Sanchit on 05/06/2026 

  toggleApplicantProfileMenu(event: MouseEvent): void {
    if (!this.showProfileMenu) {
      return;
    }
    event.stopPropagation();
    this.isApplicantProfileMenuOpen = !this.isApplicantProfileMenuOpen;
  }

  @HostListener('document:click')
  handleDocumentClick(): void {
    if (this.isApplicantProfileMenuOpen) {
      this.isApplicantProfileMenuOpen = false;
    }
  }

  handleEditProfileClick = () => {
    this.isApplicantProfileMenuOpen = false;
    this.onEditProfile?.();
  };

  handleChangePasswordClick = () => {
    this.isApplicantProfileMenuOpen = false;
    this.onChangePassword?.();
  };

  handleLogoutClick = () => {
    this.isApplicantProfileMenuOpen = false;
    this.onLogout?.();
  };
  // end by omkar on 18/03/2026
}
